import { useState } from 'react';
import { motion } from 'framer-motion';
import { Timer as TimerIcon, Hourglass } from 'lucide-react';
import { StopwatchPanel } from './StopwatchPanel';
import { CountdownPanel } from './CountdownPanel';

const TABS = [
  { id: 'stopwatch', label: 'Stopwatch', Icon: TimerIcon },
  { id: 'timer', label: 'Timer', Icon: Hourglass },
];

export const QuickTools = () => {
  const [tab, setTab] = useState('stopwatch');
  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.05 }}
      className="bg-card border border-border rounded-3xl px-4 py-6 sm:p-8 mb-8 overflow-hidden"
      data-testid="quick-tools-section"
    >
      <div className="mx-auto mb-4 flex w-fit gap-1 rounded-full bg-white/[0.05] border border-white/10 p-1">
        {TABS.map(({ id, label, Icon }) => (
          <button
            type="button"
            key={id}
            onClick={() => setTab(id)}
            className={`relative inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-xs font-heading uppercase tracking-[0.16em] transition-colors ${
              tab === id ? 'text-black' : 'text-white/60 hover:text-white'
            }`}
            data-testid={`quick-mode-${id}`}
          >
            {tab === id && <motion.span layoutId="quick-tab-pill" className="absolute inset-0 rounded-full bg-primary" />}
            <Icon className="relative h-3.5 w-3.5" />
            <span className="relative">{label}</span>
          </button>
        ))}
      </div>
      {/* Both stay mounted so a running stopwatch/timer survives tab switches */}
      <div className={tab === 'stopwatch' ? '' : 'hidden'}><StopwatchPanel /></div>
      <div className={tab === 'timer' ? '' : 'hidden'}><CountdownPanel /></div>
    </motion.section>
  );
};

export default QuickTools;
